import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import { PAGE_LAYOUT_VARIANT } from 'features/App';
import { PageLayoutContext } from 'features/App/Contexts';
import { useRegisterFooterFormPresence } from 'features/App/FooterFormPresenceContext';
import './FooterBar.scss';

const { block, element } = bem('footer-bar');

const FooterBar = ({ visible, desktopNavIsCollapsed, notice, children, className }) => {
  useRegisterFooterFormPresence(visible);

  return ReactDOM.createPortal(
    <PageLayoutContext.Consumer>
      {({ layoutInfo: { pageLayout } }) => (
        <div className={`${block({ visible })} ${className || ''}`}>
          <div
            className={element('button-container-wrap', {
              desktopNavIsCollapsed,
              wide: pageLayout === PAGE_LAYOUT_VARIANT.WIDE,
            })}>
            <div>{!!notice && notice}</div>
            <div className={element('children')}>{children}</div>
          </div>
        </div>
      )}
    </PageLayoutContext.Consumer>,
    document.body
  );
};

FooterBar.propTypes = {
  visible: PropTypes.bool,
  desktopNavIsCollapsed: PropTypes.bool,
  notice: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default FooterBar;
